import { combineReducers } from 'redux';

import webGallerySearchReducer from './search/searchReducer';
import webGalleryCartReducer from './cart/web-gallery-cart-reducer';
// new format
import webGalleryLayoutReducer from './layout/webGalleryLayoutReducer';

const webGalleryReducer = combineReducers({
  search: webGallerySearchReducer,
  cart: webGalleryCartReducer,
  layout: webGalleryLayoutReducer,
});

export default webGalleryReducer;
